<template>
    <Grid/>
</template>

<script>
    import Grid from './../components/WorkEnv/Grid'

    export default {
        components: {
            Grid,
        }
    }
</script>